<div fxLayout="column" fxLayoutAlign="center center" style="margin: auto">
	<mat-spinner></mat-spinner>
	<div class="h3 pt3">Please wait... we are currently switching the context.</div>
</div>
